import React, { Fragment, lazy, memo } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { orderBy } from "lodash";
import EmptyState from "Assets/images/empty-state/setup-strength.svg";
import useStyles from "./styles";

const StrengthChips = lazy(() =>
  import("Modules/User/CreateEditForm/Common/Chips/StrengthChips")
);

const DisplayView = () => {
  const classes = useStyles();
  const { watch } = useFormContext();
  const { listOfStrength } = watch("configuration.strengths");
  return (
    <Box px={1.5} className={classes.root} pb={4} pt={1}>
      {listOfStrength?.length ? (
        <Fragment>
          <Grid container spacing={3}>
            <Grid item>
              <Typography
                variant="subtitle2"
                className="font-semibold font-14 title-tag"
              >
                Strength tags
              </Typography>
            </Grid>
            <Grid item xs={12} sm>
              <Typography variant="subtitle2" className="font-semibold font-14">
                Description
              </Typography>
            </Grid>
          </Grid>

          {orderBy(listOfStrength, "name")?.map((res, key) => (
            <Box className="border rounded" p={2} mt={1.5}>
              <Grid container spacing={3}>
                <Grid item>
                  <StrengthChips
                    key={key}
                    index={key}
                    value={res}
                    label={res.name}
                    showCount={false}
                  />
                </Grid>
                <Grid item xs={12} sm>
                  {res?.description ? (
                    <span className="description font-14">
                      {res?.description}
                    </span>
                  ) : (
                    <span className="description f-light-gray font-14">
                      No description added
                    </span>
                  )}
                </Grid>
              </Grid>
            </Box>
          ))}
        </Fragment>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          className={classes.emptyState}
          pt={3}
        >
          <img src={EmptyState} alt="Empty state" />
          <Typography variant="body2">No strengths available</Typography>
        </Box>
      )}
    </Box>
  );
};

export default memo(DisplayView);
